// extracted by mini-css-extract-plugin
module.exports = {"container":"WatchList_container__koAs5","spacer":"WatchList_spacer__28CJk"};